// Client of the Provider Trash (/provider/trash). Same conventions as wholesaleService: plain JSON, never throws.
import { dsApi } from "./wholesaleService";

const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v !== undefined && v !== "" && v !== null && q.set(k, v));
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const listProviderTrash = (token, params) => dsApi(token, "GET", `/provider/trash${qs(params)}`);
export const restoreProviderProduct = (token, id) => dsApi(token, "POST", `/provider/trash/${encodeURIComponent(id)}/restore`, {});
export const deleteProviderProductPermanently = (token, id) => dsApi(token, "DELETE", `/provider/trash/${encodeURIComponent(id)}`);
